<app-base-auth class="wide-screen">
  <ng-container *ngIf="!result.show">
    <div style="text-align: left; padding: 20px 2px; font-weight: 600">
      {{ 'Please complete your information'  | translate | locale }}
    </div>
    <div class="login-form">
      <nz-row>
        <nz-col nzSm="24" nzMd="12" style="padding-inline: 5px">
          <nz-form-item>
            <p class="input-title">
              {{'First Name'  | translate | locale }}
            </p>
            <input
              type="text"
              nz-input
              class="border-radius"
              #PasswordControl
              [(ngModel)]="user.firstName"
            />
          </nz-form-item>
        </nz-col>
        <nz-col nzSm="24" nzMd="12" style="padding-inline: 5px">
          <nz-form-item>
            <p class="input-title">
              {{ 'Last Name' | translate  | locale }}
            </p>
            <input
              type="text"
              nz-input
              class="border-radius"
              #PasswordControl
              [(ngModel)]="user.lastName"
            />
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="24">
          <nz-form-item>
            <p class="input-title">
              {{'Phone Number' | translate | locale }}
            </p>
            <input
              type="text"
              nz-input
              class="border-radius"
              #PasswordControl
              [(ngModel)]="user.phoneNumber"
            />
          </nz-form-item>
        </nz-col>
        <!-- <nz-col nzSm="24" nzMd="12" style="padding-inline: 5px">
          <nz-form-item>
            <p class="input-title">
              {{ "Username" | locale }}
            </p>
            <input
              type="text"
              nz-input
              class="border-radius"
              #PasswordControl
              [(ngModel)]="user.userName"
            />
          </nz-form-item>
        </nz-col> -->
        <nz-col nzSpan="24">
          <nz-form-item>
            <p class="input-title">
              {{ 'Password' | translate | locale }}
            </p>
            <nz-input-group
              [nzSuffix]="showPasswordTemplate"
              class="border-radius"
            >
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                type="password"
                nz-input
                class="border-radius"
                #PasswordControl
                [(ngModel)]="user.password"
              />
            </nz-input-group>
            <ng-template #showPasswordTemplate>
              <span
                nz-icon
                [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"
              ></span>
            </ng-template>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <button
        nz-button
        nzSize="large"
        class="form-button border-radius"
        nzType="primary"
        (click)="register()"
      >
        {{'Submit' | translate | locale }}
      </button>
    </div>
  </ng-container>
  <nz-result
    *ngIf="result.show"
    nzStatus="success"
    [nzTitle]="result.title"
    [nzSubTitle]="result.subTitle"
  >
    <div nz-result-extra>
      <button [routerLink]="['/auth/login']" nz-button nzType="primary">
        {{'Go to login' | translate}}
      </button>
    </div>
  </nz-result>
</app-base-auth>
